import { HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '@nk/access-block';
import { AnalysisApiClient, RequestOptions } from '@nk/api-client-lib';
import { FileApiService } from '@nk/api-lib';
import { FileSessionEntity } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class FileService implements FileApiService {
  constructor(
    private _api: AnalysisApiClient,
    private _appService: AppService,
  ) {}

  public getFullFilePathsForFiles(
    filePathWithoutFileSession: string[],
    filePrefix: string | undefined = undefined,
    bucketName = 'general',
  ): Observable<string[]> {
    if (!filePrefix) {
      filePrefix = this._api.rootUrl + 'v1/file/';
    }
    return this._appService.identityDataCache.get().pipe(
      switchMap((identity) => {
        return this.postFileSessionForFilePaths(filePathWithoutFileSession, identity.app_customer.uuid);
      }),
      map((fileSessions) => {
        return fileSessions.map((fileSession) => {
          return `${filePrefix}${fileSession.file_path}?file_session_uuid=${fileSession.file_session_uuid}&bucket_name=${bucketName}`;
        });
      }),
    );
  }

  public postFileSessionForFilePaths(filePaths: string[], appCustomerUuid: string): Observable<FileSessionEntity[]> {
    const partialFileSessions: Partial<FileSessionEntity>[] = filePaths.map((path) => {
      return {
        app_customer_uuid: appCustomerUuid,
        file_path: path,
      };
    });

    return this._api.post<FileSessionEntity[]>(`file-session`, partialFileSessions);
  }

  public postFileWithFilePath(file: File, filepath: string, contentType: string): Observable<HttpEvent<unknown>> {
    const options = new RequestOptions();
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', contentType);
    options.headers = headers;
    return this._api.postFile(`file/${filepath}`, file, options);
  }
}
